var _defs, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStory(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 25,
    viewBox: "0 0 22 25",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "7.986%",
    y1: "100%",
    x2: "92.014%",
    y2: "0%",
    id: "stories"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6157FF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#93F",
    offset: "100%"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.25 25a.75.75 0 110 1.5H7.75a.75.75 0 110-1.5h12.5zm2-3a.75.75 0 110 1.5H5.75a.75.75 0 110-1.5h16.5zm-.134-19.5C23.709 2.5 25 3.719 25 5.222v12.556c0 1.503-1.291 2.722-2.884 2.722H5.884C4.291 20.5 3 19.281 3 17.778V5.222C3 3.719 4.291 2.5 5.884 2.5zm-.215 2.2H6.099c-.496 0-.899.371-.899.83v11.94c0 .459.403.83.9.83h15.8c.497 0 .9-.371.9-.83V5.53c0-.459-.403-.83-.9-.83z",
    transform: "translate(-3 -2)",
    fill: "url(#stories)",
    fillRule: "nonzero"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStory);
export default __webpack_public_path__ + "static/media/story.66d3e3fdfa001f6a46b8fe8cadc5d736.svg";
export { ForwardRef as ReactComponent };